import { Modules } from '../schema/Modules';
import {
    getIsUserCustomPropertiesInitializedPromise,
    getUserCustomProperties,
    setUserCustomProperties,
} from '../utils/userCustomProperties';
import { addDays, getTimestamp, now, startOfDay } from 'owa-datetime';
import * as trace from 'owa-trace';
import { UserCustomProperties, UserCustomPropertiesKeys } from '../schema/UserCustomProperties';
import { DayActivity } from '../schema/DayActivity';
import { CollectionNames } from '../utils/collectionNames';
import { ItemNames } from '../utils/itemNames';
import { upsertSDSCollectionItem } from 'mini-sds-gateway/lib/services/upsertSDSCollectionItem';

/**
 * Updates the user activity data of the user in local store and in SDS per module
 * NOTE - used the parameter as appModule instead of module since 'module' is a keyword
 * @param module Module in which the user activity is to be stored in
 */
export const updateModuleUserActivity = async (appModule: Modules) => {
    await getIsUserCustomPropertiesInitializedPromise();
    const userCustomProperties: UserCustomProperties = getUserCustomProperties();

    const userActivities = userCustomProperties?.userMonthlyActivity || {};
    const todayDate: number = getTimestamp(startOfDay(now()));
    if (!(appModule in userActivities)) {
        userActivities[appModule] = [{ day: todayDate }];
        await storeDataInSDS(userActivities);
    } else {
        const dayActivities: DayActivity[] = userActivities[appModule];
        if (!dayActivities.find(dayActivity => dayActivity.day === todayDate)) {
            dayActivities.push({ day: todayDate });

            // Remove all the activities which are previous than 30days old
            const thirtyDayOld: number = getTimestamp(addDays(startOfDay(now()), -30));
            userActivities[appModule] = dayActivities.filter(
                dayActivity => dayActivity.day >= thirtyDayOld
            );

            await storeDataInSDS(userActivities);
        }
    }
};

const storeDataInSDS = async data => {
    const response = await upsertSDSCollectionItem(
        CollectionNames.UserCustomProperties,
        ItemNames.UserCustomPropertiesItem,
        {
            userMonthlyActivity: data,
            // TODO > 30days:- Using the below line to transfer the data to items in a collection
            userNotificationPreferences: getUserCustomProperties()?.[
                UserCustomPropertiesKeys.userNotificationPreferences
            ],
        }
    );

    if (response?.Id) {
        setUserCustomProperties(UserCustomPropertiesKeys.userMonthlyActivity, data);
    } else {
        trace.errorThatWillCauseAlert(
            'Could not update user custom properties in SDS' + response?.error?.code
        );
    }
};
